var modules_39642e22 = {"bubble":"_izgza5","arrow":"_y71la6","container":"_1339yge","close":"_1ew1kqz","outline-none":"_1gom2n9"};
import "../../../assets/CLFUAYn9.css";

export { modules_39642e22 as default };
//# sourceMappingURL=Tooltip.module.less.js.map
